import { Injectable } from '@angular/core';
import { AngularFireAuth } from 'angularfire2/auth';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';
import { Subject } from 'rxjs/Subject';

import * as firebase from 'firebase/app';


@Injectable()
export class UserService {
  public  currentUser: Subject<object>;
  public  currentUserSnapshot: any = null;

  constructor(public afAuth: AngularFireAuth, public afs: AngularFirestore) {
   
    /*
    this.currentUserRef =  afs
    .doc('stations/' + environment.stationId);
    */

    /*
    this.currentUser.subscribe((updatedCurrentUser) => { 
      console.log('auth state changed. user is ' + JSON.stringify(updatedCurrentUser));
      
      // Update the current user for this station in the DB
      // The unity app should listen for these changes 
      // The current user for a given station is 
      // stations/[stationId]/currentUser, with a null value if 
      // nobody is logged in.
      let u = {};
      if (updatedCurrentUser != null) {
        u = {user: (<any>updatedCurrentUser).email};
      }
    }); */

   }

   isLoggedIn() {
     console.log("Warning! isLoggedIn() will return null if called too early")
     console.log("Use UserService.currentUser.subscribe(u => { if (u==null) })");
     return (firebase.auth().currentUser != null)
   }



   login(email, password) {
       return firebase.auth().signInWithEmailAndPassword(email, password);
   }

   logout() {
      firebase.auth().signOut().then(() => {
        console.log('signed out');
      });
    }

    signup(email, password, displayName, callback) {
      firebase.auth().createUserWithEmailAndPassword(email, password).then(
        (u) => { 
          console.log('signup successful'); 
          (<any>u).updateProfile({
            displayName: displayName
          });
          callback();
    },
        (err) => 
    { 
      console.log(JSON.stringify(err)); 
      callback(err); //err.message can be used as is
    });
  }

    // For testing: returns an observable against the 
    // firestore document holding the current user .
    getCurrentUserDbRef() {
      //return this.currentUserRef.valueChanges();
      return null;
    }

    getCurrentUser() {
      return firebase.auth().currentUser;
    }

    // simple session management system
    // just a namespaced keyvalue store in the browser local storage

    // starts a fresh session and clears the past one. do this on login
    initSession(uid: string) {

      var sessionData= {
        userId: uid,
        appState: "PRE_SURGERY",
        appData: {}
      }
      window.localStorage.setItem("MARION_APP_STATE", JSON.stringify(sessionData));
      console.log("Started new session for user "+uid);
    }

    dump(): any {
        var data = window.localStorage.getItem("MARION_APP_STATE");
        console.log('----Current Session Data----')
        console.log(data);
    }
    //Nondestructive update of session data
    //Writes the provided key value pair while leaving the rest unchanged
    //This method is not thread-safe!!!
    writeAppData(key, value): any {
      let data = JSON.parse(window.localStorage.getItem("MARION_APP_STATE"))
      data.appData[key] = value;
      window.localStorage.setItem("MARION_APP_STATE", JSON.stringify(data));
    }

    //readAppData("surgery_type") == "needle"
    readAppData(key) {
      let data = JSON.parse(window.localStorage.getItem("MARION_APP_STATE"))
      return data.appData[key];
    }

    readSessionData() {
      return JSON.parse(window.localStorage.getItem("MARION_APP_STATE"))
    }

    INIT() {
      this.currentUser = new Subject<object>();
      console.log("User service INIT")
      
        this.afAuth.authState.subscribe((auth) => {
          this.currentUserSnapshot = auth;
          this.currentUser.next(auth);
          console.log("Auth state change observable fired!")
          console.log(JSON.stringify(auth));
        })

    }
  }




// WEBPACK FOOTER //
// C:/Users/Marion Surgical/Desktop/Sean/marion-surgical-master/src/app/core/services/user.service.ts